import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_ORDER_OVERVIEW: MijnRoute = {
    path: ':id/order-overzicht',
    navigationEvent: 'toOrderOverzicht',
    regex: /^\/beleggen\/[^/]+\/order-overzicht$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/order-overzicht'
};
